import { render, staticRenderFns } from "./mzDrugDetail.vue?vue&type=template&id=3f6fbbda&scoped=true"
import script from "./mzDrugDetail.vue?vue&type=script&lang=js"
export * from "./mzDrugDetail.vue?vue&type=script&lang=js"
import style0 from "./mzDrugDetail.vue?vue&type=style&index=0&id=3f6fbbda&prod&scoped=true&lang=css"
import style1 from "./mzDrugDetail.vue?vue&type=style&index=1&id=3f6fbbda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fbbda",
  null
  
)

export default component.exports